import React, { useMemo, useRef, useState, useEffect } from "react";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import {
    Box,
    Button,
    Paper,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Chip,
    Backdrop,
    CircularProgress,
    Alert,
    Fade,
    Card,
    CardContent,
    Divider,
} from "@mui/material";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import NewComparison from "./NewComparison";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ComparisonTab from "./ComparisonTab";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";




const ComparisonHome = () => {
    const [comparisonData, setComparisonData] = useState([]);

    const loginData = useSelector((state) => state.loginData.value);

    const [auth_token] = useState(loginData?.auth_token);
    const [user_token] = useState(loginData?.user?.token);

    const [selectedComparison, setSelectedComparison] = useState(null);

    const [openComparison, setOpenComparison] = useState(false)

    const [RFQCategory, setRFQCategory] = useState({
        value: "",
        id: "",
        categoryList: [],
        isValid: true,
    });

    const [reload, setReload] = useState(false);

    const [value, setValue] = useState(1)

    useEffect(() => {
        const fetchComparisonData = async () => {
            try {
                const res = await axios.post(
                    API_ENDPOINT.get_compare_rfq,
                    { user_token: user_token },
                    { headers: { Authorization: `Bearer ${auth_token}` } }
                );
                setComparisonData(res.data.comparisons || []);
            } catch (error) {
                console.error("Error fetching comparison data:", error);
            }
        };

        fetchComparisonData();
    }, [reload]);

    const getCategoryList = () => {
        axios({
            method: "GET",
            url: `${API_ENDPOINT.list_of_prompt_category}`,
            headers: {
                Authorization: `Bearer ${auth_token}`,
            },
        })
            .then((response) => {
                let promptList = response.data.response;
                setRFQCategory({
                    ...RFQCategory,
                    categoryList: promptList,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const formatDate = (isoString) => {
        if (!isoString) return "N/A";

        const date = new Date(isoString);

        // Format into GMT explicitly
        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: "GMT",
        };

        const formattedDate = date.toLocaleString("en-GB", options);

        return formattedDate;
    };

    const handleAddComparison = () => {
        setSelectedComparison(null);   // exit view mode
        setOpenComparison(true);
        // setRFQCategory({
        //     value: "",
        //     id: "",
        //     categoryList: [],   // never undefined
        //     isValid: true,
        // });
    };

    const handleChange = (event, newValue) => {
        console.log(newValue)
        setValue(newValue);
    };



    return (
        <Box sx={{ mt: 3, px: 2 }}>

            <div >
                <HeaderTitle titleText="Comparison Automation"  />
            </div>

            {/* Tab */}

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>


                <TabContext value={value}>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label="old" value={1} />
                            <Tab label="new" value={2} />

                        </TabList>
                    </Box>


                    <TabPanel value={1} index={1}>
                        <ComparisonTab />
                    </TabPanel>



                    <TabPanel value={2} index={2}>
                        {!openComparison && (
                            <Box
                                sx={{
                                    mt: 1,
                                    mb: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: 2,
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <TextField
                                    variant="outlined"
                                    placeholder="Search (affects server RFQ items only)"
                                    size="medium"
                                    sx={{
                                        width: 360,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                        },
                                        "& input": { fontSize: 15, py: 1.2 },
                                        "& input::placeholder": { fontSize: 15, opacity: 0.7 },
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 600,
                                        textTransform: "none",
                                        px: 3,
                                        py: 1.2,
                                        borderRadius: 2,
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                    }}
                                    onClick={(e) => {
                                        handleAddComparison(e);
                                        getCategoryList();
                                    }}
                                >
                                    Add Comparison
                                </Button>
                            </Box>
                        )}

                        {openComparison ? (
                            <NewComparison
                                onBack={() => {
                                    setReload((prev) => !prev);
                                    setOpenComparison(false);
                                }}
                                RFQCategory={RFQCategory}
                                setRFQCategory={setRFQCategory}
                                user_token={user_token}
                                selectedComparison={selectedComparison}
                            />
                        ) : (
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1fr",
                                        sm: "repeat(3, 1fr)",
                                        md: "repeat(4, 1fr)",
                                    },
                                    gap: 2,
                                }}
                            >
                                {comparisonData.length === 0 ? (
                                    <Typography
                                        sx={{
                                            color: "#64748b",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            gridColumn: "1 / -1",
                                            textAlign: "center",
                                            py: 4,
                                        }}
                                    >
                                        No comparison history found
                                    </Typography>
                                ) : (
                                    comparisonData.map((item, index) => (
                                        <Card
                                            key={index}
                                            sx={{
                                                borderRadius: "12px",
                                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                                                border: "1px solid #e2e8f0",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12)",
                                                    transform: "translateY(-2px)",
                                                },
                                            }}
                                        >
                                            <CardContent sx={{ p: 3, "&:last-child": { pb: 3 } }}>
                                                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                                    <Chip
                                                        label={`PRN: ${item.prn_number}`}
                                                        sx={{
                                                            backgroundColor: "#3b82f6",
                                                            color: "white",
                                                            fontWeight: 600,
                                                            fontSize: "12px",
                                                            height: "24px",
                                                            "& .MuiChip-label": { padding: "0 8px" },
                                                        }}
                                                    />
                                                </Box>

                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "#64748b",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        mb: 3,
                                                    }}
                                                >
                                                    Compared On
                                                    <br />
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            color: "#1e293b",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {formatDate(item.created_on)}
                                                    </Box>
                                                </Typography>

                                                <Divider sx={{ my: 1, borderColor: "#f1f5f9" }} />

                                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <Button
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: "#f1f5f9",
                                                            color: "#475569",
                                                            border: "1px solid #e2e8f0",
                                                            borderRadius: "8px",
                                                            fontWeight: 600,
                                                            fontSize: "11px",
                                                            textTransform: "none",
                                                            padding: "4px 10px",
                                                            "&:hover": {
                                                                backgroundColor: "#e2e8f0",
                                                                borderColor: "#cbd5e1",
                                                            },
                                                        }}
                                                        onClick={() => {
                                                            setOpenComparison(true);
                                                            setSelectedComparison(item);
                                                        }}
                                                    >
                                                        VIEW DETAIL
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    ))
                                )}
                            </Box>
                        )}
                    </TabPanel>


                </TabContext>



            </Box>






        </Box>
    );
};

export default ComparisonHome;